import * as Sentry from "@sentry/browser";
import axios from "axios";

import type { SSOProviderId } from "@app/common/types/providerTypes";
import { getDomainFromEmail } from "@app/common/utils";

const hasDomain = (results: { data: string }[], domain: string) =>
  results.some(({ data }) => data.includes(domain));

export const getProviderFromEmail = async (
  email: string
): Promise<SSOProviderId | "email"> => {
  const domain = getDomainFromEmail(email ?? "");

  try {
    const res = await axios.get(
      `https://dns.google.com/resolve?name=${domain}&type=MX`,
      { withCredentials: false }
    );

    const results = res.data.Answer ?? [];

    // the purpose of this check is to try to save ourselves and the user a step by
    // connecting their SSO and calendar in a single request. google and microsoft
    // are currently the only two calendar providers we support; if/when additional
    // calendar providers are supported we should add a check for them here
    if (hasDomain(results, "google")) {
      return "google";
    }

    if (hasDomain(results, "outlook")) {
      return "microsoft_graph";
    }
  } catch (e) {
    Sentry.captureException(e);
  }

  return "email";
};
